import template from './top-nav.template.html';
import controller from './top-nav.controller';

const topNavComponent = {
  template,
  controller,
  controllerAs: 'topNavCtrl'
};

export default topNavComponent;



// WEBPACK FOOTER //
// ./ui/src/components/top-nav/top-nav.component.js